<template>
    <Dialog
        :open="open"
        title="Bulk Edit Fulfillment Orders"
        @close="emit('close')"
    >
        <div class="columns is-multiline">
            <div class="column is-4">
                <Field
                    v-model="form.parcelLength"
                    type="number"
                    label="Parcel Length (inches)"
                    :error="form.errors.parcelLength"
                />
            </div>

            <div class="column is-4">
                <Field
                    v-model="form.parcelWidth"
                    type="number"
                    label="Parcel Width (inches)"
                    :error="form.errors.parcelWidth"
                />
            </div>

            <div class="column is-4">
                <Field
                    v-model="form.parcelHeight"
                    type="number"
                    label="Parcel Height (inches)"
                    :error="form.errors.parcelHeight"
                />
            </div>

            <div class="column is-4">
                <Field
                    v-model="form.parcelOunces"
                    type="number"
                    label="Parcel Weight (oz)"
                    :error="form.errors.parcelOunces"
                />
            </div>
        </div>

        <hr>

        <div class="is-width-100 is-flex is-justify-content-flex-end">
            <button
                class="button is-primary"
                :class="{
                    'is-loading': form.processing,
                }"
                @click.prevent="handleSave"
            >
                Bulk Save
            </button>
        </div>
    </Dialog>
</template>

<script setup lang="ts">
import Dialog from "@/Components/Dialog.vue";
import Field from "@/Components/common/Field.vue";
import {useForm} from "@inertiajs/vue3";

const props = defineProps<{
    open: boolean;
    selectedIds: number[];
}>();

const emit = defineEmits<{
    (e: 'close'): void;
}>();

const form = useForm({
    parcelLength: '',
    parcelWidth: '',
    parcelHeight: '',
    parcelOunces: '',
});

function handleSave() {
    form.transform((data) => {
        return {
            ...data,
            selectedIds: props.selectedIds
        }
    }).post(route('admin.self_fulfillment.orders.bulk_update'), {
        onSuccess: () => {
            emit('close');
        },
    });
}
</script>
